import React from 'react'
import './SubscriptionPayment.css'

function SubscriptionPayment() {
    return (
        <div className="home">
            <div className="main-subscription">
                <a href="#" className="text-primary mb-4 d-block">
                    ← Back
                </a>
                <div>
                    <h4 className="fw-bold" style={{ fontSize: '32px' }}>Review & Confirm Your Plan</h4>
                    <p className="text-muted">
                        Choose your billing preferences and enter payment details to
                        activate your account.
                    </p>

                </div>
                <div className="row">
                    {/* Left Side */}
                    <div className="col-md-6 mb-4">

                        <div className="d-flex flex-column gap-3 rounded-3 p-4">
                            <h5 className="fw-semibold mb-0" >Subscribe to Business</h5>
                            <div className="d-flex align-items-center ">
                                <div className="ms-3 d-flex align-items-center gap-3">
                                    <span className="fs-4 fw-bold" style={{ fontSize:'32px' }}>$20/user/month</span>
                                    <div className='d-flex flex-column align-items-center justify-content-center'>
                                        <label className="form-label mb-0 small">Users</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            style={{ width: "80px" }}
                                            value={4}
                                            readOnly
                                        />
                                    </div>
                                </div>
                            </div>

                            <hr />
                            <div className="d-flex justify-content-between align-items-center">
                                <span>Subtotal :</span>
                                <span className="fw-semibold" style={{ fontSize:'28px' }}>$80.00</span>
                            </div>

                            <button className="btn btn-muted w-50" disabled>
                                Apply Promo Code
                            </button>

                            <hr />
                            <div className="d-flex justify-content-between align-items-center">
                                <span className="fw-semibold">Total due today :</span>
                                <span className="fw-bold"style={{ fontSize:'28px' }}>$80.00</span>
                            </div>

                            <p className="small text-muted mt-3">
                                This is a recurring subscription. You will be charged automatically
                                at the start of each billing cycle until you cancel.
                            </p>
                        </div>
                    </div>

                    {/* Right Side */}
                    <div className="col-md-6">
                        <div className="border bg-white rounded-5 p-4 shadow-lg d-flex flex-column" style={{ gap: "24px" }}>
                            <h6 className=" fw-semibold mb-0" style={{ fontSize:'32px' }}>Pay with card</h6>

                            <input
                                type="email"
                                className="form-control "
                                placeholder="johndoe@samplemail.com"
                            />

                            <input
                                type="text"
                                className="form-control "
                                placeholder="1234 1234 1234 1234"
                            />

                            <div className="d-flex  gap-2">
                                <input type="text" className="form-control" placeholder="MM / YY" />
                                <input type="text" className="form-control" placeholder="CVC" />
                            </div>

                            <input
                                type="text"
                                className="form-control "
                                placeholder="Full name on card"
                            />

                            <select className="form-select ">
                                <option>India</option>
                                <option>United States</option>
                                <option>UK</option>
                            </select>

                            <input type="text" className="form-control " placeholder="PIN" />

                            <button className="theme-rounded-btn w-50 mx-auto rounded-pill">
                                Subscribe
                            </button>

                            <p className="text-muted text-center small w-50 mx-auto">
                                Payments are securely processed by Stripe. We never store your card
                                information.
                            </p>
                            <p className="text-muted text-center small w-75 mx-auto">
                                By completing your purchase, you agree to our{" "}
                                <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>.
                            </p>
                            <p className="small text-center">
                                Need help? Contact us at{" "}
                                <a href="mailto:info@brainyagent.ai">info@brainyagent.ai</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SubscriptionPayment